// Helper for labelling tournament days like "11. April" with a German
// weekday prefix ("Sa, 11. April"). Year is inferred from an optional
// year in the label, falling back to the current year.

const GERMAN_MONTHS = {
  januar: 0,
  februar: 1,
  maerz: 2,
  "märz": 2,
  april: 3,
  mai: 4,
  juni: 5,
  juli: 6,
  august: 7,
  september: 8,
  oktober: 9,
  november: 10,
  dezember: 11,
};

const WEEKDAYS_DE_SHORT = ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"];

export const getWeekdayForDayLabel = (dayLabel) => {
  if (!dayLabel || typeof dayLabel !== "string") return "";
  const match = dayLabel.match(
    /(\d{1,2})\.\s*([A-Za-zäöüÄÖÜß]+)(?:\s+(\d{4}))?/
  );
  if (!match) return "";
  const day = parseInt(match[1], 10);
  const monthName = match[2].toLowerCase();
  const month = GERMAN_MONTHS[monthName];
  if (month === undefined) return "";
  const year = match[3] ? parseInt(match[3], 10) : new Date().getFullYear();
  const date = new Date(year, month, day);
  if (Number.isNaN(date.getTime())) return "";
  return WEEKDAYS_DE_SHORT[date.getDay()];
};

export const formatDayWithWeekday = (dayLabel) => {
  const weekday = getWeekdayForDayLabel(dayLabel);
  return weekday ? `${weekday}, ${dayLabel}` : dayLabel;
};
